<template>
  <div id="app">
    <component :is="layout" v-if="msal.isAuthenticated">
      <router-view />
    </component>

    <Loading v-else :show="true">
    </Loading>

    <app-modal />
    <app-notify />
  </div>
</template>

<script>
  const default_layout = "sem-sidebar";

  export default {
    name: 'App',
    computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + "-layout";
      }
    }
  }
</script>

<style>
</style>
